module.exports = __webpack_public_path__ + "static/media/video-placeholder.12e7ced8.jpg";